/**
 * Utilitaire pour wrapper automatiquement les appels API avec refresh instantané
 * Utilisé pour déclencher la mise à jour des compteurs après chaque opération CRUD
 */

// Variable globale pour stocker la fonction de refresh
let globalRefreshFunction = null;

// Fonction pour définir la fonction de refresh globale
export const setGlobalRefreshFunction = (refreshFn) => {
  globalRefreshFunction = refreshFn;
};

// Fonction pour déclencher un refresh global
export const triggerGlobalRefresh = (action, entityType) => {
  if (globalRefreshFunction) {
    console.log(`🔄 Refresh automatique après ${action} sur ${entityType}`);
    // Petit délai pour s'assurer que l'opération backend est terminée
    setTimeout(() => {
      globalRefreshFunction(true); // Force refresh
    }, 100);
  }
};

// Wrapper pour les opérations d'ajout
export const wrapAddOperation = (operation, entityType) => {
  return async (...args) => {
    try {
      const result = await operation(...args);
      triggerGlobalRefresh('ajout', entityType);
      return result;
    } catch (error) {
      console.error(`Erreur lors de l'ajout de ${entityType}:`, error);
      throw error;
    }
  };
};

// Wrapper pour les opérations de mise à jour
export const wrapUpdateOperation = (operation, entityType) => {
  return async (...args) => {
    try {
      const result = await operation(...args);
      triggerGlobalRefresh('modification', entityType);
      return result;
    } catch (error) {
      console.error(`Erreur lors de la modification de ${entityType}:`, error);
      throw error;
    }
  };
};

// Wrapper pour les opérations de suppression
export const wrapDeleteOperation = (operation, entityType) => {
  return async (...args) => {
    try {
      const result = await operation(...args);
      triggerGlobalRefresh('suppression', entityType);
      return result;
    } catch (error) {
      console.error(`Erreur lors de la suppression de ${entityType}:`, error);
      throw error;
    }
  };
};

// Fonction pour wrapper automatiquement un service complet
export const wrapService = (service, entityType) => {
  const wrappedService = { ...service };
  
  // Wrapper les méthodes d'ajout
  if (service.add) {
    wrappedService.add = wrapAddOperation(service.add, entityType);
  }
  
  // Wrapper les méthodes de mise à jour
  if (service.update) {
    wrappedService.update = wrapUpdateOperation(service.update, entityType);
  }
  
  // Wrapper les méthodes de suppression
  if (service.delete) {
    wrappedService.delete = wrapDeleteOperation(service.delete, entityType);
  }
  
  return wrappedService;
};

export default {
  setGlobalRefreshFunction,
  triggerGlobalRefresh,
  wrapAddOperation,
  wrapUpdateOperation,
  wrapDeleteOperation,
  wrapService
};
